/** Build-time release switches. Missing values keep unfinished features private.
 * Set these only in a deliberately reviewed build, never from query parameters.
 */
export const releaseFeatures = {
  paywalls: process.env.NEXT_PUBLIC_PAYWALLS_ENABLED === "true",
  learning: process.env.NEXT_PUBLIC_LEARNING_ENABLED === "true",
  profileProgress: process.env.NEXT_PUBLIC_PROFILE_PROGRESS_ENABLED === "true",
  accountRedesign: process.env.NEXT_PUBLIC_ACCOUNT_REDESIGN_ENABLED === "true",
  streaks: process.env.NEXT_PUBLIC_STREAKS_ENABLED === "true",
  dailyPractice: process.env.NEXT_PUBLIC_DAILY_PRACTICE_ENABLED === "true",
  persistentGuests: process.env.NEXT_PUBLIC_PERSISTENT_GUESTS_ENABLED === "true",
} as const;
